<template>
  <div class="case-content-box">
    <Header></Header>
    <div class="works-content-box">
      <img class="works-banner" src="../assets/image/worksShow/banner.png" />
      <div class="container">
        <div v-if="previewObj" class="right-all-box">
          <div class="platform-pc">
            <div class="case-title">{{previewObj.title}}</div>
            <div class="case-info">
              <div class="info-label">标&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;签：</div>
              <div class="info-con">
                <span v-for="item,index in previewObj.tags.split(',')" :key="index">{{item}}</span>
              </div>
            </div>
            <div class="case-info">
              <div class="info-label">指导教师：</div>
              <div class="info-con">{{previewObj.teachers}}</div>
            </div>
            <div class="case-info">
              <div class="info-label">团队成员：</div>
              <div class="info-con">{{previewObj.work_members}}</div>
            </div>
            <div id="jeol-caseVideo-pc" class="case-video-box">
              <div v-for="item,index in previewObj.cases_attachments" :key="index" class="video-items">
                <video v-if="item.covert_status == 2" :id="`player-pc-${index}`" playsinline webkit-playsinline></video>
                <div v-else-if="item.covert_status == 3" class="trans-cover">
                  <img src="../assets/image/student/unitTwo/transerror.jpg" alt="" />
                </div>
                <div v-else class="trans-cover">
                  <img src="../assets/image/student/unitTwo/translate.png" alt="" />
                </div>
              </div>
            </div>
            <div class="content-txt ql-editor" v-html="previewObj.content"></div>

          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import services from '../assets/js/services'
import Header from "../components/Header.vue";
import { mapState } from "vuex";
export default {
  name: "CaseDetail",
  components: {
    Header,
  },
  data () {
    return {
      previewObj: null,
      id: null,
    }
  },
  computed: {
    ...mapState({
      appsUserInfo: state => state.appsLogin.appsUserInfo,
    }),
  },
  mounted () {
    let queryId = this.$route.query.id
    if (queryId) {
      this.id = queryId
      this.getData()
    }
  },
  methods: {
    async getData () {
      let result = await services.getCasesDetail({ id: this.id })
      if (result.code == "0000") {
        this.previewObj = result.data
        if (this.previewObj.cases_attachments && this.previewObj.cases_attachments.length > 0) {
          for (let i = 0; i <= this.previewObj.cases_attachments.length; i++) {
            if (this.previewObj.cases_attachments[i] && this.previewObj.cases_attachments[i].file_id) {
              this.$nextTick(() => {
                window.setTimeout(() => {
                  this.initPlayer(`player-pc-${i}`, this.previewObj.cases_attachments[i].file_id, 'pc', i)
                }, 300);
              })
            }
          }
        }
      }
    },
    // 初始化腾讯云播放器
    initPlayer (idDom, file_id, type, index) {
      let playName = 'palyer' + type + index
      this[playName] = window.TCPlayer(idDom, {
        width: 464,
        height: 261,
        fileID: file_id,
        appID: '1500004122',
        posterImage: true,
        bigPlayButton: true,
        autoplay: false,
        controlBar: {
          playbackRateMenuButton: true,
          QualitySwitcherMenuButton: false,
        }
      });
    },
  }


}
</script>

<style lang="less" scoped>
.works-content-box {
    padding: 0 0 40px;
    background-color: #fff;
    min-height: 100vh;
    .container {
      width: 1000px;
      padding: 0 0;
      margin: 0 auto;
    }
    .works-banner {
        width: 100%;
        height: auto;
        margin-bottom: 24px;
    }
    .right-all-box {
        width: 100%;
        .case-title {
            font-size: 22px;
            color: #191919;
            line-height: 34px;
            text-align: center;
            padding-bottom: 20px;
            border-bottom: 1px solid #e7e9f1;
            margin-bottom: 20px;
        }
        .case-info {
            display: flex;
            align-items: baseline;
            margin-bottom: 10px;
            .info-label {
                font-weight: bold;
                font-size: 14px;
                color: #373536;
                width: 70px;
            }
            .info-con {
                flex: 1;
                font-weight: 400;
                font-size: 14px;
                color: #494e57;
                span {
                    display: inline-block;
                    padding: 3px 14px;
                    text-align: center;
                    background: #f4f3f3;
                    border-radius: 14px;
                    margin-bottom: 5px;
                    margin-right: 10px;
                }
            }
        }
        .case-video-box {
            padding-bottom: 20px;
            border-bottom: 1px solid #e7e9f1;
            margin-bottom: 20px;
            .video-items {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-bottom: 10px;
                .trans-cover img {
                  width: 464px;
                  height: auto;
                }
            }
        }
        .content-txt {
          padding: 0 !important;
            p {
              font-size: 14px;
              color: #5c5f6b;
              line-height: 26px;
              text-indent: 2rem;
            }
            p:has(img, audio, video) {
                text-align: center;
                text-indent: 0 !important;
            }
            /deep/ img {
              max-width: 90%;
              height: auto;
              display: block;
              margin: 5px auto;
            }
            /deep/ ul {
              margin: inherit;
              // padding: 0;
            }
            /deep/ ol {
              margin: inherit;
              // padding: 0;
            }
            /deep/ a {
              color: #06c;
              text-decoration: underline;
            }
        }
    }
}
</style>